import { Swiper, SwiperSlide } from 'swiper/react';
import { AgentDetailCard } from 'components/AgentDetailCard';
import { Navigation } from 'swiper/modules';
import { ISearchListingsOutputParams } from './SearchListingsOutput';
import { IArtifactComponentProps } from 'types/services';
import { IAgent } from 'types/artifacts/common';
import { IAgentListArtifact } from 'types/artifacts/agent-list';
import { ResultsCountAndSeeMore } from 'components/ResultsCountAndSeeMore';
import { isProduction } from 'scripts/application/setting';

export type IAgentListOutputProps = IArtifactComponentProps<
    ISearchListingsOutputParams,
    IAgentListArtifact
>;

AgentListOutput.artifactKey = "search_agent";

export function AgentListOutput(props: IAgentListOutputProps): JSX.Element {
    const { search_id, artifacts } = props;

    // if there is no valid artifacts return from the backend
    if (!Array.isArray(artifacts)) return <></>;

    if (search_id) {
        const artifact = artifacts.find((x) => x.id === search_id);
        const agents = artifact?.search_agent || [];
        const agentsCount = agents.length;

        if (artifact && agentsCount > 0) {
            const seeMore = () => {
                // doing this because the spelling of platinum is coming wrong from the backend ans also on frontend its filter based on 1 not on true                 
                const replacedUrl = artifact?.response?.url.replace("/member?", "");
                return `https://www.har.com/realestatepro/search?${replacedUrl}`;
            };
            return (
                <>
                    <Swiper
                        className="swiper-properties agent_list_slider"
                        spaceBetween={10}
                        slidesPerGroup={1}         // ✅ next button moves 1 card
                        modules={[Navigation]}
                        navigation={true}
                        autoHeight={true}
                        pagination={{ clickable: true }}
                        breakpoints={{
                            0: {
                                slidesPerView: "auto",
                                slidesPerGroup: 1,
                                spaceBetween: 10,
                            },
                            768: {
                                slidesPerView: "auto",
                                slidesPerGroup: 1,
                                spaceBetween: 12,
                            },
                            1067: {
                                slidesPerView: 2,      // ✅ desktop shows 3 full cards
                                slidesPerGroup: 1,     // keep 1 if you want step-by-step
                                spaceBetween: 10,
                            },
                        }}
                    >
                        {agents.map((agent, index) => (
                            <SwiperSlide
                                key={index}
                                className={agentsCount < 4 ? 'swiper-slider-item' : ''}
                            >
                                <AgentDetailCard agent={agent as IAgent} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <ResultsCountAndSeeMore seeMore={seeMore} count={agentsCount} total={artifact.response.total} />
                </>
            );
        }

        console.error(
            "No agents found for 'AgentListOutput' with the given search_id:",
            search_id
        );

        return <></>;
    }

    console.error(
        "No search_id provided for 'AgentListOutput'."
    );

    return <></>;
}

AgentListOutput.asText = function (props: IAgentListOutputProps): string {
    // console.log("AgentListOutput.asText", props);
    return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.artifact_text || "" : isProduction ? "" : "AgentListOutput asText Not Implemented!";
}